import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';
import { setCallToAbandoned } from '../callHandlers/callStateHandler';

function handleSessionRescinded(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const userId = context.userId;
  const eventUserId = event.userId;
  const task = TasksModule.getTask(event.sessionSid);

  // we don't want to handle for other users even if we find the task
  // this could happen if the user makes an outbound via queue
  // and then the queue rollovers
  if (!task || userId !== eventUserId) {
    return;
  }

  if (task.state === TaskState.Offered) {
    setCallToAbandoned({
      context,
      sessionSid: event.sessionSid,
      eventType: 'session-rescinded',
    });
  }
}

export default handleSessionRescinded;
